export default "__VITE_ASSET__d454b5a4__"